module.exports = __webpack_public_path__ + "img/cloud.193417e7.png";